<template>
  <div>
    <v-row wrap>
      <v-col cols="12" sm="12">
        <v-card>
          <v-card-text>
            <v-row align-center>
              <v-col cols="12" sm="6">
                <v-list two-line>
                  <v-list-item>
                    <v-list-item-action>
                      <v-icon color="primary">mdi-clock-outline</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title class="body-1 font-weight-bold">{{
                        $vuetify.lang.t("$vuetify.dashboard.filter.title") }}
                      </v-list-item-title>
                      <v-list-item-subtitle>{{ $vuetify.lang.t("$vuetify.dashboard.filter.title2") }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-col>
              <v-col cols="12" sm="6">
                <div class="text-right">
                  <v-btn @click="showFilter()" class="my-6" color="primary" outlined>{{
                    $vuetify.lang.t("$vuetify.dashboard.filter.title3",
                    [filter.createdAt.start], [filter.createdAt.end]) }}
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="12">
        <v-timeline>
          <v-timeline-item
            :color="getColorType(item.type)"
            :icon="getIconType(item.type)"
            :key="item.id"
            large
            v-for="item in items"
          >
            <template v-slot:opposite>
              <span :class="`subtitle-1 font-weight-bold ${getColorType(item.type)}--text`">{{ $moment(item.createdAt).format('YYYY-MM-DD HH:mm:ss') }}</span>
            </template>
            <v-card class="elevation-2">
              <v-card-title :class="`headline font-weight-light mb-2 ${getColorType(item.type)}--text`">{{
                getTypeTitle(item.type) }}
                <v-spacer></v-spacer>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn @click="viewOperation(item.id)" color="red darken-4" icon small text v-on="on">
                      <v-icon>mdi-eye-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $vuetify.lang.t('$vuetify.application.btn.view.title') }}</span>
                </v-tooltip>
              </v-card-title>
              <v-card-text :class="`body-1 ${getColorType(item.type)}--text`">
                <v-row>
                  <v-col :sm="showJsonRender(item.id)?5:12" cols="12">
                    {{ item.comment }}
                  </v-col>
                  <template v-if="showJsonRender(item.id)">
                    <v-divider vertical></v-divider>
                    <v-col cols="12" sm="6">
                      <json-viewer
                        :value="getJsonRender(item.id)"
                        boxed
                        copyable>
                      </json-viewer>
                    </v-col>
                  </template>
                </v-row>
              </v-card-text>
            </v-card>
          </v-timeline-item>
          <v-timeline-item
            color="pink"
            icon="mdi-alert-outline"
            large
            v-if="_.isEmpty(items)"
          >
            <template v-slot:opposite>
              <span
                class="subtitle-1 font-weight-bold pink--text">{{ $moment().format('YYYY-MM-DD HH:mm:ss') }}</span>
            </template>
            <v-card class="elevation-2">
              <v-card-title class="subtitle-1 font-weight-bold pink--text">{{
                $vuetify.lang.t("$vuetify.operation.timeline.no_activity.title") }}
              </v-card-title>
              <v-card-text class="body-1">{{ $vuetify.lang.t("$vuetify.operation.timeline.no_activity.message") }}
              </v-card-text>
            </v-card>
          </v-timeline-item>
        </v-timeline>
        <infinite-loading :identifier="limit" @infinite="infiniteHandler">
          <div slot="no-more">{{ $vuetify.lang.t("$vuetify.operation.timeline.no_more") }}</div>
          <div slot="no-results">{{ $vuetify.lang.t("$vuetify.operation.timeline.no_data") }}</div>
        </infinite-loading>
      </v-col>
    </v-row>
    <filter-form :dialog="dialog" :filter="filter" @performFilter="loadItems" ref="filterForm"></filter-form>
  </div>
</template>

<script>
  import ListMixin from "./../../mixins/Common/List";
  import FilterForm from '../dashboard/Filter';
  import URLPath from "../../helpers/URL";

  export default {
    mixins: [ListMixin],
    name: "Index",
    props: {
      card: {
        type: Object,
        default: function () {
          return {
            title: true,
            maxHeight: "max-height: 500px"
          };
        }
      },
      user: {
        type: Object,
        default: function () {
          return {
            id: null,
            username: null,
            profile: {
              fullName: null
            }
          };
        }
      }
    },
    created() {
      let date = new Date();
      date.setDate(date.getDate() - 30);
      this.filter.createdAt.start = date.toISOString().substr(0, 10);
    },
    data: () => ({
      urlItems: "/operations",
      limit: 5,
      newState: false,
      filter: {
        createdAt: {
          start: new Date().toISOString().substr(0, 10),
          end: new Date().toISOString().substr(0, 10)
        }
      },
      dialog: {
        title: "$vuetify.application.btn.new",
        show: false,
        saveBtnTitle: '$vuetify.btn.save',
        isDisabled: false,
        action: "create"
      },
      jsonRender: []
    }),
    watch: {
      "user.id": function () {
        this.loadItems();
      }
    },
    methods: {
      getIconType(type) {
        switch (type) {
          case "payment":
            return "mdi-cards";
          case "user":
            return "mdi-account-multiple-outline";
          case "provision":
            return "mdi-cash";
          case "profile":
            return "mdi-account-settings";
          case "transfer":
            return "mdi-bank-transfer";
          default:
            return "mdi-apps";
        }
      },
      getColorType(type) {
        switch (type) {
          case "payment":
            return "teal";
          case "user":
            return "pink";
          case "provision":
            return "primary";
          case "profile":
            return "amber";
          case "transfer":
            return "indigo";
          default:
            return "secondary";
        }
      },
      loadItems() {
        this.pagination.itemsPerPage = 5;
        this.pagination.page = 1;
        this.pagination.sortBy = ["o_id"];
        this.pagination.sortDesc = [true];
        this._search = this.buildSearchQuery();
        this.newState = true;
        this.limit = 5;
        this.getItems().then((response) => {
          let total = response.data.meta.total;
          if (total > this.limit)
            this.limit += 1;
          this.$refs.filterForm.closeDialog();
        });
      },
      getTypeTitle(type) {
        return this.$vuetify.lang.t("$vuetify.operationType." + type);
      },
      infiniteHandler($state) {
        this.pagination.page = 1;
        this.pagination.sortBy = ["o_id"];
        this.pagination.sortDesc = [true];
        this.pagination.itemsPerPage = (this.newState) ? 5 : this.limit;
        this._search = this.buildSearchQuery();
        this.newState = false;
        this.getItems().then((response) => {
          let total = response.data.meta.total;
          if (total <= this.limit) {
            $state.complete();
          } else {
            $state.loaded();
            this.limit += 1;
          }
        });
      },
      buildSearchQuery() {
        let query = "";
        if (this.user.id) query = "o_userId::eq::" + this.user.id;
        if (this.filter.createdAt.start) {
          if (this._.isEmpty(query)) {
            query = "o_createdAt::lte::" + this.$moment(this.filter.createdAt.end).endOf('day').format("x");
            query += ",o_createdAt::gte::" + this.$moment(this.filter.createdAt.start).startOf('day').format("x");
          } else {
            query += ",o_createdAt::lte::" + this.$moment(this.filter.createdAt.end).endOf('day').format("x");
            query += ",o_createdAt::gte::" + this.$moment(this.filter.createdAt.start).startOf('day').format("x");
          }
        }
        if (this._.isEmpty(query)) query = null;
        return query;
      },
      showFilter() {
        this.dialog.title = this.$vuetify.lang.t("$vuetify.dashboard.filter.title");
        this.dialog.saveBtnTitle = this.$vuetify.lang.t('$vuetify.dashboard.btn.filter.title');
        this.dialog.show = true;
      },
      viewOperation(key) {
        if (this.checkJsonRender(key)) {
          this.changeJsonRender(key);
        } else {
          this.getOperation(key);
        }
      },
      getOperation(key) {
        let params = {};
        params["url"] = URLPath.OPERATION.LIST + "/" + key;
        let self = this;
        let message = this.$vuetify.lang.t("$vuetify.error_occured");
        this.$store
          .dispatch("request", params)
          .then(response => {
            this.addJsonRender({data: response.data, show: true});
          })
          .catch(err => {
            if (err.response) {
              if (err.response.status === 403) {
                message = self.$vuetify.lang.t("$vuetify.error_denied");
              }
            }
            self.$store.dispatch("setNotification", {
              status: true,
              message: message
            });
          })
      },
      addJsonRender(value) {
        this.jsonRender.push(value);
      },
      changeJsonRender(key) {
        this._.forEach(this.jsonRender, (o, clef) => {
          if (o["data"]["id"] === key) {
            this.jsonRender[clef].show = !o.show;
          }
        });
      },
      getJsonRender(key) {
        let data = {};
        this._.forEach(this.jsonRender, (o, clef) => {
          if (o["data"]["id"] === key) {
            data = this.jsonRender[clef].data.data;
            return data;
          }
        });
        return data;
      },
      checkJsonRender(key) {
        let filter = this._.filter(this.jsonRender, function (o) {
          return o["data"]["id"] === key;
        });
        return !this._.isEmpty(filter);
      },
      showJsonRender(key) {
        if (this.checkJsonRender(key)) {
          let filter = this._.filter(this.jsonRender, function (o) {
            return o["data"]["id"] === key;
          });
          if (this._.isEmpty(filter)) return false;
          return filter[0].show;
        }
        return false;
      }
    },
    components: {
      FilterForm
    }
  }
</script>

<style scoped>
  .jv-container.jv-light {
    font-size: 12px !important;
    font-family: "Lato", sans-serif !important;
  }

  .jv-container.jv-light .jv-item.jv-string {
    color: #1D46D2;
  }
</style>
